"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _enhanceFormControl = _interopRequireDefault(require("./enhance-form-control"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var className = function className(props) {
  return (0, _classnames.default)('CountBox', {});
};

var isValidInput = function isValidInput(n, min, max) {
  if (n === '' || Number.isInteger(Number(n)) && n < 10) {
    return true;
  }

  var isNumber = Number.isInteger(Number(n));
  var isBiggerThanMin = min ? n >= min : true;
  var isSmallerThanMax = max ? n <= max : true;
  return isNumber && isBiggerThanMin && isSmallerThanMax;
};

var CountBox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CountBox, _React$Component);

  function CountBox() {
    _classCallCheck(this, CountBox);

    return _possibleConstructorReturn(this, _getPrototypeOf(CountBox).apply(this, arguments));
  }

  _createClass(CountBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.value && this.props.onChange) {
        this.props.onChange(this.props.value, this.props.name);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var props = this.props;
      return _react.default.createElement("div", {
        className: className(props)
      }, _react.default.createElement("input", _extends({}, props, {
        ref: function ref(_ref) {
          return _this.input = _ref;
        },
        onChange: function onChange(e) {
          if (isValidInput(e.target.value, props.min, props.max)) {
            props.onChange(Number(e.target.value) || '', e.target.name);
          }
        },
        onBlur: function onBlur(e) {
          if (props.value < props.min) {
            props.onChange(props.min);
            props.onBlur ? props.onBlur(props.min) : null;
          } else {
            props.onBlur ? props.onBlur(props.min) : null;
          }
        },
        className: "CountBox__input"
      })), _react.default.createElement("button", {
        type: "button",
        className: "CountBox__substract",
        disabled: Number(props.value) <= props.min,
        onClick: function onClick(e) {
          if (props.onClickSubstract) {
            return props.onClickSubstract(props.value);
          }

          var step = _this.props.step || 1;
          props.onChange(props.value - step, _this.input.name);
        }
      }, "-"), _react.default.createElement("button", {
        type: "button",
        className: "CountBox__add",
        disabled: props.max && Number(props.value) >= props.max,
        onClick: function onClick() {
          if (props.onClickAdd) {
            return props.onClickAdd(props.value);
          }

          var step = _this.props.step || 1;
          props.onChange(Number(props.value) + step, _this.input.name);
        }
      }, "+"));
    }
  }]);

  return CountBox;
}(_react.default.Component);

CountBox.defaultProps = {
  min: 1
};

var _default = (0, _enhanceFormControl.default)(CountBox);

exports.default = _default;